/* AWARE · carrinho lateral — 20/10/2026
   Complementa o main.js do tema (não o substitui). O main.js continua a tratar de
   abrir/fechar, quantidades, remover artigos e redesenhar a gaveta.
   Aqui ficam só as partes novas:
     1) código de desconto (a mesma mecânica de antes: regista o código no carrinho,
        confirma que pegou e redesenha — o cliente só sai quando carrega em Finalizar);
     2) "Costumam levar também" (recomendações da Shopify) com escolha de tamanho;
     3) pequenos cuidados: manter a posição da lista e o código aberto entre redesenhos,
        e o fundo escuro a fechar a gaveta mesmo depois de um redesenho;
     4) manter o código aplicado guardado para seguir para o awarehome.pt
        (sessionStorage.aware_discount, lido pela secção aware_ligacao do tema). */
(function () {
  'use strict';

  if (window.__awCarrinho) { return; }
  window.__awCarrinho = true;

  var TXT = {
    vazio: 'Escreve o código primeiro.',
    aplicar: 'A aplicar…',
    invalido: 'Código inválido ou que não se aplica a este carrinho.',
    falhou: 'Não foi possível aplicar agora. Tenta novamente.',
    tamanho: 'Escolhe o tamanho primeiro.',
    erro: 'Não foi possível adicionar. Tenta novamente.'
  };

  var estado = { corpo: null, scroll: 0, alvoScroll: null, subirAoTopo: false, codigoAberto: false, limpezaPendente: false };
  var cacheSugestoes = {};

  function gaveta() { return document.querySelector('cart-drawer'); }

  /* ---------------------------------------------------------------
     Redesenhar com o mecanismo do próprio tema (renderContents):
     mantém o relógio a contar, volta a ligar o fundo escuro, etc.
     --------------------------------------------------------------- */
  function aplicarSecoes(secoes, abrir) {
    var g = gaveta();
    if (!g || !secoes || !secoes['cart-drawer']) { throw new Error('sem gaveta'); }
    if (typeof g.renderContents === 'function') {
      g.renderContents({ sections: secoes }, !abrir);
      return;
    }
    var doc = new DOMParser().parseFromString(secoes['cart-drawer'], 'text/html');
    var nova = doc.querySelector('#CartDrawer');
    var atual = document.getElementById('CartDrawer');
    if (!nova || !atual) { throw new Error('sem gaveta'); }
    atual.innerHTML = nova.innerHTML;
  }

  function redesenhar() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) { throw new Error('http ' + r.status); }
        return r.json();
      })
      .then(function (secoes) { aplicarSecoes(secoes, false); });
  }

  /* ---------------------------------------------------------------
     1) Código de desconto
     --------------------------------------------------------------- */

  /* O código ficou mesmo aplicado? Esta loja não devolve cart.discount_applications
     no /cart.js, por isso procuramos o NOME do código dentro dos artigos
     (confirmado em teste real: {"amount": 600, "title": "CARRINHO10"}). */
  function codigoAplicado(cart, codigo) {
    if (!cart) { return false; }
    var alvo = String(codigo).trim().toUpperCase();
    function bate(t) { return String(t || '').trim().toUpperCase() === alvo; }

    var itens = cart.items || [];
    for (var i = 0; i < itens.length; i++) {
      var ds = itens[i].discounts || [];
      for (var j = 0; j < ds.length; j++) {
        if (bate(ds[j].title)) { return true; }
      }
      var als = itens[i].line_level_discount_allocations || [];
      for (var k = 0; k < als.length; k++) {
        var da = als[k].discount_application || {};
        if (bate(da.title) || bate(da.code)) { return true; }
      }
    }
    var cl = cart.cart_level_discount_applications || [];
    for (var c = 0; c < cl.length; c++) {
      if (cl[c].type === 'discount_code' && (bate(cl[c].title) || bate(cl[c].code))) { return true; }
    }
    var apps = cart.discount_applications || [];
    for (var a = 0; a < apps.length; a++) {
      if (bate(apps[a].title) || bate(apps[a].code)) { return true; }
    }
    /* Não inventamos: se o nome do código não aparece, não foi aplicado. */
    return false;
  }

  function mensagem(form, texto, ok) {
    var p = form.querySelector('.aw-c__codigo-msg');
    if (!p) { return; }
    p.textContent = texto;
    p.hidden = false;
    p.classList.toggle('is-ok', !!ok);
    p.classList.toggle('is-erro', !ok);
  }

  function limparMensagem(form) {
    var p = form.querySelector('.aw-c__codigo-msg');
    if (p) { p.hidden = true; p.textContent = ''; }
  }

  function aplicarCodigo(form) {
    var campo = form.querySelector('[name="aw-codigo"]');
    var botao = form.querySelector('button[type="submit"]');
    var codigo = campo && campo.value ? campo.value.trim() : '';

    if (!codigo) {
      mensagem(form, TXT.vazio, false);
      if (campo) { campo.focus(); }
      return;
    }
    if (form.classList.contains('is-loading')) { return; }

    limparMensagem(form);
    var rotulo = botao ? botao.textContent : '';
    form.classList.add('is-loading');
    if (botao) { botao.textContent = TXT.aplicar; botao.disabled = true; }

    function terminar() {
      form.classList.remove('is-loading');
      if (botao) { botao.textContent = rotulo; botao.disabled = false; }
    }

    /* 1) Registar o código no carrinho (o ?redirect=/cart.js devolve logo o carrinho). */
    fetch('/discount/' + encodeURIComponent(codigo) + '?redirect=/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(function (cart) {
        /* 2) Se não veio o carrinho na resposta, vamos buscá-lo. */
        if (cart && cart.items) { return cart; }
        return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        /* 3) Pegou? */
        if (!codigoAplicado(cart, codigo)) {
          terminar();
          mensagem(form, TXT.invalido, false);
          return;
        }
        /* Guardado para o resto da sessão (é assim que se sabe que não é um resto antigo). */
        try { sessionStorage.setItem('aware_discount', codigo.toUpperCase()); } catch (e) {}
        window.AWARE_DISCOUNT_CODE = codigo.toUpperCase();
        estado.codigoAberto = true;

        /* 4) Redesenhar a gaveta com os totais novos (aparece o código com o ×). */
        return redesenhar().catch(function () {
          /* Os totais têm de estar certos: se não der para redesenhar, recarrega. */
          window.location.reload();
        });
      })
      .catch(function () {
        terminar();
        mensagem(form, TXT.falhou, false);
      });
  }

  function removerCodigo() {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).then(function () {
      try { sessionStorage.removeItem('aware_discount'); } catch (e) {}
      window.AWARE_DISCOUNT_CODE = null;
      document.cookie = 'discount_code=; Max-Age=0; path=/';
    });
  }

  /* 02/11/2026: deixou de se apagar o código que ainda está no carrinho quando o cookie de sessão discount_code
     já não existe (antes: verificarCodigoAntigo -> removerCodigo). Assim, quem volta com o código de um creator
     continua com ele. O código só sai quando o cliente carrega no × do código (removerCodigo). */

  /* O código aplicado segue para o awarehome.pt pela "ligação" do tema (secção aware_ligacao),
     que o lê de sessionStorage.aware_discount / window.AWARE_DISCOUNT_CODE. A gaveta é a fonte
     da verdade (vem desenhada pela Shopify), por isso mantemos os dois sempre iguais a ela —
     também depois de o cliente mudar de página (antes o código perdia-se aí). */
  function sincronizarCodigo(corpo) {
    if (estado.limpezaPendente || !corpo) { return; }
    var lista = corpo.getAttribute('data-aw-codigos');
    if (lista === null) { return; }
    var cod = lista.split(',').map(function (s) { return s.trim(); }).filter(Boolean)[0] || '';
    cod = cod.toUpperCase();
    try {
      if (cod) { sessionStorage.setItem('aware_discount', cod); } else { sessionStorage.removeItem('aware_discount'); }
    } catch (e) {}
    window.AWARE_DISCOUNT_CODE = cod || null;
  }

  /* ---------------------------------------------------------------
     2) Costumam levar também
     --------------------------------------------------------------- */
  function preencherSugestoes() {
    var g = gaveta();
    if (!g) { return; }
    var caixa = g.querySelector('[data-aw-sugestoes]');
    if (!caixa || caixa.getAttribute('data-aw-pronto')) { return; }
    caixa.setAttribute('data-aw-pronto', '1');

    var pid = caixa.getAttribute('data-produto');
    if (!pid) { return; }
    if (Object.prototype.hasOwnProperty.call(cacheSugestoes, pid)) {
      montarSugestoes(caixa, cacheSugestoes[pid]);
      return;
    }
    var base = caixa.getAttribute('data-url') || '/recommendations/products';
    function pedir(intencao) {
      var url = base + '?section_id=aware-carrinho-sugestoes&product_id=' + encodeURIComponent(pid) + '&limit=10&intent=' + intencao;
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; });
    }
    /* Primeiro as "complementares" (se um dia forem escolhidas na app Search & Discovery);
       se não houver, as "relacionadas" automáticas da Shopify. */
    pedir('complementary')
      .then(function (html) { return html && html.indexOf('data-aw-sug-produto') !== -1 ? html : pedir('related'); })
      .then(function (html) {
        cacheSugestoes[pid] = html || '';
        var atual = gaveta() && gaveta().querySelector('[data-aw-sugestoes]');
        if (atual && atual.getAttribute('data-produto') === pid) { montarSugestoes(atual, cacheSugestoes[pid]); }
      })
      .catch(function () { cacheSugestoes[pid] = ''; });
  }

  function montarSugestoes(caixa, html) {
    var alvo = caixa.querySelector('[data-aw-sug-alvo]');
    if (!alvo || !html) { caixa.hidden = true; return; }

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var cartoes = doc.querySelectorAll('[data-aw-sug-produto]');
    var excluir = (caixa.getAttribute('data-excluir') || '').split(',');
    var tamanhos = (caixa.getAttribute('data-tamanhos') || '').split('|').filter(Boolean);
    var vistos = {};
    var n = 0;

    alvo.innerHTML = '';
    for (var i = 0; i < cartoes.length && n < 8; i++) {
      var id = cartoes[i].getAttribute('data-aw-sug-produto');
      if (!id || vistos[id] || excluir.indexOf(id) !== -1) { continue; }
      vistos[id] = true;
      var cartao = document.importNode(cartoes[i], true);
      preEscolherTamanho(cartao, tamanhos);
      alvo.appendChild(cartao);
      n++;
    }
    caixa.hidden = n === 0;
    /* A lista ganhou altura: agora já dá para repor a posição onde o cliente estava. */
    if (estado.corpo && estado.corpo.contains(caixa)) { reporScroll(); }
  }

  /* Se o cliente já tem um tamanho no carrinho (ex.: 42 nas sapatilhas, M na roupa),
     a sugestão já vem com esse tamanho escolhido. Se não houver, fica "Tamanho". */
  function preEscolherTamanho(cartao, tamanhos) {
    var sel = cartao.querySelector('select[data-aw-sug-variante]');
    if (!sel || !tamanhos.length) { return; }
    var opcoes = sel.querySelectorAll('option[data-aw-op]');
    for (var t = 0; t < tamanhos.length; t++) {
      for (var o = 0; o < opcoes.length; o++) {
        var partes = String(opcoes[o].getAttribute('data-aw-op') || '').split(' / ');
        for (var p = 0; p < partes.length; p++) {
          if (partes[p].trim().toUpperCase() === tamanhos[t].trim().toUpperCase()) {
            sel.value = opcoes[o].value;
            return;
          }
        }
      }
    }
  }

  function avisoCartao(cartao, texto) {
    var p = cartao && cartao.querySelector('.aw-c__sug-aviso');
    if (!p) { return; }
    p.textContent = texto || '';
    p.hidden = !texto;
  }

  function adicionarSugestao(botao) {
    var cartao = botao.closest('[data-aw-sug-produto]');
    var campo = cartao && cartao.querySelector('[data-aw-sug-variante]');
    var id = campo && campo.value;
    if (!id) {
      if (campo && campo.tagName === 'SELECT') { campo.classList.add('is-erro'); campo.focus(); }
      avisoCartao(cartao, TXT.tamanho);
      return;
    }
    if (botao.disabled) { return; }
    botao.disabled = true;
    avisoCartao(cartao, '');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.j || res.j.status) {
          botao.disabled = false;
          avisoCartao(cartao, (res.j && (res.j.description || res.j.message)) || TXT.erro);
          return;
        }
        /* Avisa o resto do tema (ex.: a página /cart), como faz o botão do produto. */
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'aware-sugestoes' });
          }
        } catch (e) {}
        estado.subirAoTopo = true;
        var g = gaveta();
        if (g) { g.classList.remove('is-empty'); }
        if (res.j.sections) {
          aplicarSecoes(res.j.sections, false);
        } else {
          redesenhar().catch(function () { window.location.reload(); });
        }
      })
      .catch(function () {
        botao.disabled = false;
        avisoCartao(cartao, TXT.erro);
      });
  }

  /* ---------------------------------------------------------------
     3) Depois de cada redesenho (quantidades, remover, códigos, sugestões)
     --------------------------------------------------------------- */
  function aoMudar() {
    var g = gaveta();
    if (!g) { return; }
    var ativa = g.classList.contains('active');
    /* Gaveta fechada: da próxima vez abre no topo e com o código fechado. */
    if (!ativa) { estado.scroll = 0; estado.codigoAberto = false; }
    var corpo = g.querySelector('.aw-c__corpo');
    if (corpo && corpo !== estado.corpo) {
      var anterior = estado.corpo;
      estado.corpo = corpo;
      if (estado.subirAoTopo) {
        estado.subirAoTopo = false;
        estado.alvoScroll = 0;
      } else if (anterior && ativa && estado.scroll) {
        /* Redesenho com a gaveta aberta (ex.: + ou −): a lista não salta para o topo. */
        estado.alvoScroll = estado.scroll;
      } else {
        estado.alvoScroll = null;
      }
      var det = g.querySelector('[data-aw-codigo]');
      if (det && estado.codigoAberto && !det.open) { det.open = true; }
      sincronizarCodigo(corpo);
      /* Primeiro as sugestões (vêm da memória e dão a altura toda à lista), depois a posição. */
      if (ativa) { preencherSugestoes(); }
      reporScroll();
      return;
    }
    if (ativa) { preencherSugestoes(); }
  }

  function reporScroll() {
    var corpo = estado.corpo;
    if (!corpo || estado.alvoScroll === null) { return; }
    corpo.scrollTop = estado.alvoScroll;
    estado.scroll = corpo.scrollTop;
    /* Se ainda não chegou lá (a lista ainda não tem a altura toda), volta a tentar quando as sugestões chegarem. */
    if (Math.abs(corpo.scrollTop - estado.alvoScroll) < 2) { estado.alvoScroll = null; }
  }

  /* ---------------------------------------------------------------
     Ligações (por delegação: a gaveta é redesenhada muitas vezes)
     --------------------------------------------------------------- */
  document.addEventListener('submit', function (ev) {
    var form = ev.target && ev.target.closest ? ev.target.closest('[data-aw-codigo-form]') : null;
    if (!form) { return; }
    ev.preventDefault();
    aplicarCodigo(form);
  });

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) { return; }

    var rem = t.closest('[data-aw-remover-codigo]');
    if (rem) {
      ev.preventDefault();
      rem.disabled = true;
      removerCodigo().then(redesenhar).catch(function () { window.location.reload(); });
      return;
    }

    var mais = t.closest('[data-aw-sug-adicionar]');
    if (mais) {
      ev.preventDefault();
      adicionarSugestao(mais);
      return;
    }

    /* Fundo escuro: fecha sempre, mesmo depois de um redesenho. */
    if (t.id === 'CartDrawer-Overlay') {
      var g = gaveta();
      if (g && g.classList.contains('active') && typeof g.close === 'function') { g.close(); }
    }
  });

  document.addEventListener('change', function (ev) {
    var s = ev.target;
    if (s && s.matches && s.matches('select[data-aw-sug-variante]')) {
      s.classList.remove('is-erro');
      avisoCartao(s.closest('[data-aw-sug-produto]'), '');
    }
  });

  document.addEventListener('input', function (ev) {
    var t = ev.target;
    if (t && t.name === 'aw-codigo' && t.closest) {
      var f = t.closest('[data-aw-codigo-form]');
      if (f) { limparMensagem(f); }
    }
  });

  document.addEventListener('scroll', function (ev) {
    var t = ev.target;
    if (t && t.classList && t.classList.contains('aw-c__corpo')) { estado.scroll = t.scrollTop; }
  }, true);

  document.addEventListener('toggle', function (ev) {
    var t = ev.target;
    if (t && t.matches && t.matches('[data-aw-codigo]')) { estado.codigoAberto = t.open; }
  }, true);

  function arrancar() {
    var g = gaveta();
    if (!g) { return; }
    aoMudar();
    if (window.MutationObserver) {
      new MutationObserver(aoMudar).observe(g, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
